import { useMutation, useQuery } from "react-query";
import { fetchApi } from "helpers/reactQueryApi";
import { Appointment, Calendar } from "../../@types/appointments";
import { stringify } from "query-string";
import useTranslation from "../../hooks/useTranslation";

export async function createAppointmentContact({ appointmentId, ...body }) {
  return fetchApi(`/appointments/${appointmentId}/contact`, {
    method: "POST",
    body,
  });
}

export function useCreateAppointmentContact(options) {
  return useMutation(createAppointmentContact, options);
}

type UseAppointmentArgs = {
  date: string;
  view: "sheet" | "list" | string;
  participating: boolean;
  options?: object;
};
export function useAppointments({
  date,
  view,
  participating,
  options = { keepPreviousData: true },
}: UseAppointmentArgs) {
  const isoDate = date.split("T")[0];
  const params = {
    date: isoDate,
    view,
    type: "month",
  };

  return useQuery<Appointment[]>(
    `/appointments${participating ? "/participating" : ""}?${stringify(
      params,
    )}`,
    options,
  );
}

export function useAppointment<T = Appointment>(
  id?: string,
  translateTo?: string,
) {
  const url = `/appointments/${id}`;

  const { data, ...rest } = useQuery<T>(url, {
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  const { data: translated } = useTranslation(translateTo, "appointment", id);

  return {
    data: data && translated ? { ...data, ...translated } : data,
    ...rest,
  };
}

export function useCalendars(groupSlug: string = "") {
  return useQuery<Calendar[]>(
    `${groupSlug ? `/groups/${groupSlug}` : ""}/calendars`,
    {
      refetchOnWindowFocus: false,
    },
  );
}

export function createAppointment(body) {
  return fetchApi(`/appointments`, {
    method: "POST",
    body,
  });
}
export function useCreateAppointment(options) {
  return useMutation(createAppointment, options);
}

export function updateAppointment({ appointmentId, ...body }) {
  return fetchApi(`/appointments/${appointmentId}`, {
    method: "PUT",
    body,
  });
}
export function useUpdateAppointment(options) {
  return useMutation(updateAppointment, options);
}
